// <define:__environment__>
var define_environment_default = { infuraApiKey: "" };

// libs/core/src/lib/environment/get-environment-value.ts
var requiredEnvFields = [
  "oneInchDevPortalHost",
  "walletConnectProjectId"
];
var env = {
  oneInchDevPortalHost: "https://api.1inch.dev"
};
var embeddedMode = false;
function getEnvironmentValue(valueName) {
  if (embeddedMode && env[valueName] === void 0 && requiredEnvFields.includes(valueName)) {
    throw new Error(`environment value ${valueName} not exist`);
  }
  if (embeddedMode) {
    return env[valueName];
  }
  return define_environment_default[valueName] ?? env[valueName];
}
function setEnvironmentValue(valueName, value) {
  env[valueName] = value;
}
function enabledEmbeddedMode() {
  embeddedMode = true;
}
export {
  enabledEmbeddedMode,
  getEnvironmentValue,
  setEnvironmentValue
};
//# sourceMappingURL=index.esm.js.map
